import { useMergedOptions } from "../selectors/useMergedOptions";
import classNames from "classnames";
import { useContext } from "react";
import DruidWebchatContext, { DruidWebchatContextType } from "../WebChatContext";
import PropTypes from 'prop-types';


export const ConversationHistorySeparator = (props) => {
    const { onClick, children } = props;
    const [druidWebChatState, druidWebChatDispatch, ,druidStyleToEmotionObject] = useContext<DruidWebchatContextType>(DruidWebchatContext);

    const { 
        styleOptions : { subtle, accent, sendBoxButtonColorOnDisabled, sendBoxButtonColorOnHover, sendBoxButtonColorOnFocus, paddingRegular } = {},
        disabled,
        UI: { buttonsTextColor, headerTextColor, rootFontSize, headerButtonColorOnFocus, headerFontSize } = {}
        } = useMergedOptions();

    const ROOT_STYLE = {
        '&.wc-conversation-history-separator': {
            border: `1px #535874 solid`,
            height: 0,
            marginTop: 25,
            marginBottom: 25,
            marginLeft: 25,
            position: 'relative',
            cursor: 'pointer',
            '> span': {
                top: -8,
                position: 'absolute',
                backgroundColor: '#535874',
                color: 'white',
                paddingLeft: 10,
                paddingRight: 10,
                borderRadius: 15,
                fontSize: 12,
                left: '2%',
            }
        }
      };
    const rootClassName = druidStyleToEmotionObject(ROOT_STYLE) + '';
    return <div onClick={onClick} className={classNames('wc-conversation-history-separator',  rootClassName + '')}><span>{children}</span></div>;
}

// ConversationHistorySeparator.propTypes = {
//     props: PropTypes.shape({
//         className: PropTypes.string,
//         onClick: PropTypes.func,
//     }),
//     children: PropTypes.node.isRequired
//   };